import React from "react";

import WebWhisperArea from "./WebWhisperArea";
import EmoticItem from "../classtalk/emoticon/EmoticItem";
import EmoticList from "../classtalk/emoticon/EmoticList";
import AudioRecord from "../classtalk/voiceMemo/AudioRecord";
import InputGroupBox from "../classtalk/InputGroupBox";
import FunctionList from "../classtalk/FunctionList";

const WebWhisperModal = ({ openInfo, isLiveChattingLocked, msgInfo, whisperMemberSeq, isProgressBarShow, progressCount, handleSelectedClassTalkFunc }) => {
    return (
        <div className="d-flex flex-column pbl-chat-screen pbl-whisper-wrapper">
            {
                // 20260908 수정: 웹 귓속말 업로드 중에는 모달 안에서 진행 상태를 바로 확인할 수 있게 한다.
                isProgressBarShow &&
                <div className="web-whisper-upload-progress" role="progressbar" aria-valuenow={progressCount} aria-valuemin="0" aria-valuemax="100">
                    <span className="web-whisper-upload-label">파일 업로드 중</span>
                    <div className="web-whisper-upload-track">
                        <div className="web-whisper-upload-fill" style={{ width: `${progressCount}%` }}></div>
                    </div>
                    <span className="web-whisper-upload-percent">{progressCount}%</span>
                </div>
            }
            <WebWhisperArea
                msgInfo={msgInfo}
                handleSelectedClassTalkFunc={handleSelectedClassTalkFunc}
            />
            {
                openInfo.selectedEmoticonSeq > -1 &&
                <EmoticItem
                    selIndex={openInfo.selectedEmoticonSeq}
                    handleSelectedClassTalkFunc={handleSelectedClassTalkFunc}
                />
            }
            {
                openInfo.isEmoticonSelected &&
                <EmoticList
                    handleSelectedClassTalkFunc={handleSelectedClassTalkFunc}
                />
            }
            {
                openInfo.isAudioOpened ?
                    <AudioRecord
                        onHandleClassTalkFunc={handleSelectedClassTalkFunc}
                        handleSelectedClassTalkFunc={handleSelectedClassTalkFunc}
                    /> :
                    <InputGroupBox
                        selIndex={openInfo.selectedEmoticonSeq}
                        isLiveChattingLocked={isLiveChattingLocked}
                        onHandleClassTalkFunc={handleSelectedClassTalkFunc}
                        handleSelectedClassTalkFunc={handleSelectedClassTalkFunc}
                    />
            }
            {
                openInfo.isAddFunctionOpened &&
                <FunctionList
                    isWhisper={true}
                    isChatting={true}
                    whisperMemberSeq={whisperMemberSeq}
                    isSpeakingMode={false}
                    isActiveLive={false}
                    isPanelWindowOpened={false}
                    onHandleClassTalkFunc={handleSelectedClassTalkFunc}
                    handleSelectedClassTalkFunc={handleSelectedClassTalkFunc}
                />
            }
        </div>
    );
}

export default WebWhisperModal;
